import { all, fork, put, takeLatest, call, takeEvery } from 'redux-saga/effects';
import {
    getShipmentsBaselineCost,
    getShipmentsBaselineRatedCost,
    getShipmentsBaselineCostCount,
    getShipmentsCostByCarrier,
    getShipmentsCostByTimeframe,
    getShipmentsCostOverview,
} from '../../helpers';
import {
    savingsKpisApiResponseSuccess,
    savingsKpisApiResponseError,
} from './actions';
import { SavingsKpisActionTypes } from './constants';
import { addToast } from '../actions';

export function* getShipmentsBaselineCostSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsBaselineCost, query);
        yield put(savingsKpisApiResponseSuccess(SavingsKpisActionTypes.GET_SHIPMENTS_BASELINE_COST_REQUEST, response.data));
    } catch (error) {
        yield put(savingsKpisApiResponseError(SavingsKpisActionTypes.GET_SHIPMENTS_BASELINE_COST_REQUEST, error));
    }
}

export function* getShipmentsBaselineRatedCostSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsBaselineRatedCost, query);
        yield put(savingsKpisApiResponseSuccess(SavingsKpisActionTypes.GET_SHIPMENTS_BASELINE_RATED_COST_REQUEST, response.data));
    } catch (error) {
        yield put(savingsKpisApiResponseError(SavingsKpisActionTypes.GET_SHIPMENTS_BASELINE_RATED_COST_REQUEST, error));
    }
}

export function* getShipmentsBaselineCostCountSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsBaselineCostCount, query);
        yield put(savingsKpisApiResponseSuccess(SavingsKpisActionTypes.GET_SHIPMENTS_BASELINE_COST_COUNT_REQUEST, response.data));
    } catch (error) {
        yield put(savingsKpisApiResponseError(SavingsKpisActionTypes.GET_SHIPMENTS_BASELINE_COST_COUNT_REQUEST, error));
    }
}

export function* getShipmentsCostByCarrierSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsCostByCarrier, query);
        yield put(savingsKpisApiResponseSuccess(SavingsKpisActionTypes.GET_SHIPMENTS_COST_BY_CARRIER_REQUEST, response.data));
    } catch (error) {
        yield put(savingsKpisApiResponseError(SavingsKpisActionTypes.GET_SHIPMENTS_COST_BY_CARRIER_REQUEST, error));
    }
}

export function* getShipmentsCostByTimeframeSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsCostByTimeframe, query);
        yield put(savingsKpisApiResponseSuccess(SavingsKpisActionTypes.GET_SHIPMENTS_COST_BY_TIMEFRAME_REQUEST, response.data));
    } catch (error) {
        yield put(savingsKpisApiResponseError(SavingsKpisActionTypes.GET_SHIPMENTS_COST_BY_TIMEFRAME_REQUEST, error));
    }
}

export function* getShipmentsCostOverviewSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsCostOverview, query);
        yield put(savingsKpisApiResponseSuccess(SavingsKpisActionTypes.GET_SHIPMENTS_COST_OVERVIEW_REQUEST, response.data));
    } catch (error) {
        yield put(savingsKpisApiResponseError(SavingsKpisActionTypes.GET_SHIPMENTS_COST_OVERVIEW_REQUEST, error));
    }
}

export function* watchGetShipmentsBaselineCostSaga() {
    yield takeLatest(SavingsKpisActionTypes.GET_SHIPMENTS_BASELINE_COST_REQUEST, getShipmentsBaselineCostSaga);
}

export function* watchGetShipmentsBaselineRatedCostSaga() {
    yield takeLatest(SavingsKpisActionTypes.GET_SHIPMENTS_BASELINE_RATED_COST_REQUEST, getShipmentsBaselineRatedCostSaga);
}

export function* watchGetShipmentsBaselineCostCountSaga() {
    yield takeLatest(SavingsKpisActionTypes.GET_SHIPMENTS_BASELINE_COST_COUNT_REQUEST, getShipmentsBaselineCostCountSaga);
}

export function* watchGetShipmentsCostByCarrierSaga() {
    yield takeLatest(SavingsKpisActionTypes.GET_SHIPMENTS_COST_BY_CARRIER_REQUEST, getShipmentsCostByCarrierSaga);
}

export function* watchGetShipmentsCostByTimeframeSaga() {
    yield takeLatest(SavingsKpisActionTypes.GET_SHIPMENTS_COST_BY_TIMEFRAME_REQUEST, getShipmentsCostByTimeframeSaga);
}

export function* watchGetShipmentsCostOverviewSaga() {
    yield takeLatest(SavingsKpisActionTypes.GET_SHIPMENTS_COST_OVERVIEW_REQUEST, getShipmentsCostOverviewSaga);
}

function* savingsKpisSaga() {
    yield all([
        fork(watchGetShipmentsBaselineCostSaga),
        fork(watchGetShipmentsBaselineRatedCostSaga),
        fork(watchGetShipmentsBaselineCostCountSaga),
        fork(watchGetShipmentsCostByCarrierSaga),
        fork(watchGetShipmentsCostByTimeframeSaga),
        fork(watchGetShipmentsCostOverviewSaga),
    ]);
}

export default savingsKpisSaga;
